exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".character-background {\n  position: absolute;\n  top: 0;\n  left: 244px;\n  width: 300px;\n  height: 600px;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  opacity: 0.4;\n}\n", ""]);

